import React, { useReducer, useContext } from 'react'
import reducers from './reducers'

export const ProgramContext = React.createContext({})
export const ProgramProvider = function(props) {
  const state = useReducer(reducers, {})
  return <ProgramContext.Provider value={state} {...props} />
}

export const useProgramContext = () => {
  const context = useContext(ProgramContext)
  if (!context) {
    throw new Error('useProgramContext must live below ProgramProvider')
  }
  return context
}

